// eslint-disable-next-line no-unused-vars
export default theme => ({
  root: {},
  alignLeft: {
    align: 'left',
  }
});
